import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var ArrowLeft = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "none",
        "stroke": "currentColor",
        "strokeLinecap": "round",
        "strokeLinejoin": "round",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("line", { x1: 19, x2: 5, y1: 12, y2: 12, key: "k0" }),
        React.createElement("polyline", { points: "12 19 5 12 12 5", key: "k1" })));
});
ArrowLeft.displayName = 'ArrowLeft';
export var ArrowLeftDimensions = { height: 24, width: 24 };
